import { createFileRoute } from "@tanstack/react-router";
import { HospitalerPage, hospitalerHead } from "@/pages/HospitalerPage";

export const Route = createFileRoute("/brancher/hospitaler-sundhed")({
  head: () => hospitalerHead("da"),
  component: () => <HospitalerPage locale="da" />,
});
